
define('hbs!app/dashboard/DashboardListItemView.hbs',['hbs','handlebars'], function(hbs, Handlebars){var t = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "<button class=\"icon-triangle-down\"></button>";
},"3":function(depth0,helpers,partials,data) {
    return "<li class=\"menu-edit\">Edit</li>";
},"5":function(depth0,helpers,partials,data) {
    return "<li class=\"menu-remove\">Remove</li>";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "<a href=\"\">"
    + this.escapeExpression(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"name","hash":{},"data":data}) : helper)))
    + "</a>"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showDashMenu : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n\n<div class=\"menu\">\n	<ol>\n		"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isOwner : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n		"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.canBeDeleted : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n	</ol>\n</div>";
},"useData":true});Handlebars.registerPartial('app/dashboard/DashboardListItemView.hbs', t);return t;});
